import React, { useEffect, useMemo, useRef, useState } from "react";
import Tree from "react-d3-tree";
import { useGetSharedChartDataQuery } from "../../store/chart/ChartApiSlice";
import { useParams } from "react-router-dom";
import { renderNodeWithImage, transformDataToTree } from "./Orgnizationchart";
import LottieLoader from "../loader/LottieLoader";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OrgChart } from "d3-org-chart";
import noProfile from "../../../src/assets/images/dashboard-image/noProfile.jpg";
function SharedChart() {
  const [selectedNode, setSelectedNode] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTeamBased, setIsTeamBased] = useState(false);
  const param = useParams();
  const containerRef = useRef(null);
  const {
    isFetching: isLoading,
    data,
    error,
  } = useGetSharedChartDataQuery({
    share_id: param.id,
  });

  // Data is present, render OrgChart
  const treeDatas = transformDataToTree(data?.employees);
  const treeData = useMemo(
    () => (treeDatas?.length ? structuredClone(treeDatas) : []),
    [treeDatas]
  );

  const showTable = useMemo(() => {
    // Team-based logic check
    console.log(
      "data",
      data?.share_details?.filters?.department_ids?.length > 0 ||
        data?.share_details?.filters?.team_ids?.length > 0
    );

    return (
      data?.share_details?.filters?.department_ids?.length > 0 ||
      data?.share_details?.filters?.team_ids?.length > 0
    );
  }, [data]);


  useEffect(() => {
    if (!containerRef.current || !treeData?.length || isTeamBased) return;

    const lastOccurrence = {};
    const updatedTreeData = treeData?.map((item) => {
      const updatedItem = { ...item };
      if (item.parentId && lastOccurrence.hasOwnProperty(item.parentId)) {
        updatedItem.parentIdOld = item.parentId;
        updatedItem.parentId = lastOccurrence[item.parentId];
      }
      lastOccurrence[item.eid.toString()] = item.id;
      return updatedItem;
    });

    const rootNode = treeData.find((item) => !item.parentId);
    const rootNodeId = rootNode?.id ?? rootNode;
    const chart = new OrgChart()
      .container(containerRef.current)
      .data(updatedTreeData)
      .nodeWidth((d) => 240)
      .nodeHeight((d) => 150)
      .childrenMargin((d) => 110)
      .compactMarginBetween((d) => 45)
      .neighbourMargin((a, b) => 25)
      .siblingsMargin((d) => 25)
      .nodeContent((d, i, arr, state) => {
        const isRoot = d.data.id === rootNode;
        return `
                <div style="font-family: Arial; background-color:none;height:${
                  d.height
                }px;">
                  <div style="background-color:${
                    isRoot ? "#ffffff" : "#5bbba9"
                  };margin-left:1px;height:${
          d.height - 2
        }px;border-radius:10px; border: ${
          isRoot ? "2px solid #5bbba9" : "none"
        }">
              <div style="display:flex;justify-content:center;">
                <img src="${d.data?.imageUrl || noProfile}" style="margin-top:${
          isRoot ? "10" : "-30"
        }px;border-radius:${isRoot ? "0" : "100"}px;width:${
          isRoot ? "100" : "60"
        }px;height:${
          isRoot ? "50" : "60"
        }px;object-fit:contain; background-color: white; border:1px solid #5bbba9" />
                    </div>
                    <div style="color:${
                      isRoot ? "#5bbba9" : "#ffffff"
                    };font-size:16px;font-weight:bold;text-align:center;margin-top:${
          isRoot ? "5" : "35"
        }px;">
                      ${d.data?.name || "N/A"}
                    </div>
                    <div style="color:${
                      isRoot ? "#5bbba9" : "#ffffff"
                    };font-size:14px;text-align:center;margin-top:5px;">
                      ${d.data.positionName || ""}
                    </div>
                  </div>
                </div>
              `;
      });

    chart.expandAll().fit();
    chart.render();
  }, [treeData, isTeamBased]);

  console.log("isTeamBased", isTeamBased);

  const renderTable = () => {
    return (
      <>
        <h3
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          Organization List
        </h3>
        <TableContainer
          component={Paper}
          style={{
            overflowX: "auto",
            width: "80%",
            margin :"16px auto"
          }}
        >
          <Table
            style={{
              minWidth: 600,
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Image</TableCell>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Name</TableCell>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Email</TableCell>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Phone</TableCell>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Team</TableCell>
                <TableCell style={{fontWeight:"700", fontSize:"15px", textAlign:"center"}}>Position Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.employees?.map((employee) => (
                <TableRow key={employee.id}>
                  <TableCell >
                    <img
                      src={employee?.imageUrl || noProfile}
                      alt="employee"
                      style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </TableCell>
                  <TableCell style={{textAlign:"center"}}>{employee?.name || "N/A"}</TableCell>
                  <TableCell style={{textAlign:"center"}}>{employee?.email || "N/A"}</TableCell>
                  <TableCell style={{textAlign:"center"}}>{employee?.phone || "N/A"}</TableCell>
                  <TableCell style={{textAlign:"center"}}>{employee?.team || "N/A"}</TableCell>
                  <TableCell style={{textAlign:"center"}}>{employee?.positionName || "N/A"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          backgroundColor: "transparent",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LottieLoader />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100vh",
        }}
      >
        <h1>No data available</h1>
      </Box>
    );
  }

  if (showTable) {
    return renderTable();
  }

  // if (data?.employees?.length) {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h3>Organization Chart</h3>
      <div
        style={{ height: "calc(100vh - 78px)", width: "100vw" }}
        ref={containerRef}
      >
        {/* <Tree
            data={transformDataToTree(data?.employees)}
            pathFunc="Diagonal"
            separation={{ siblings: 2, nonSiblings: 2 }}
            orientation={"vertical"}
            renderCustomNodeElement={(rd3tProps) =>
              renderNodeWithImage({
                ...rd3tProps,
                setSelectedNode,
                setIsModalOpen,
              })
            }
            nodeSize={{ x: 200, y: 450 }}
            translate={{ x: 500, y: 100 }}
            enableLegacyTransitions
          /> */}
      </div>
    </div>
  );
  // }
}

export default SharedChart;
